import { FONT_SIZE, mq, Heading as _Heading, Button as _Button, COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ROOT_PADDING } from "~/styles/padding";

export const DivRootFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 ${ROOT_PADDING.PC}px ${ROOT_PADDING.PC}px;

  ${mq.sp} {
    gap: 16px;
    padding: 0 ${ROOT_PADDING.SP}px ${ROOT_PADDING.SP}px;
  }
`;

export const UlNavList = styled.ul`
  list-style: disc;
  padding-left: 16px;
  font-size: ${FONT_SIZE.XS}px;
  color: ${COLOR.GRAY500.code};

  ${mq.sp} {
    font-size: ${FONT_SIZE.XXS}px;
  }
`;

export const Heading = styled(_Heading)`
  font-size: 24px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.L}px;
  }
`;

export const ParText = styled.p`
  font-size: ${FONT_SIZE.S}px;
  margin-bottom: 8px;
`;

export const DivFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CloseButton = styled(_Button)`
  width: 240px;
  height: 48px;
  font-size: ${FONT_SIZE.M}px;
  color: ${COLOR.GRAY50.code};
  background-color: ${COLOR.GRAY900.code};

  ${mq.sp} {
    width: 200px;
    height: 48px;
  }
`;
